<template lang="html">
	<div style="position:absolute">
		<div class="hidden-xs-only spot-list-sm" id="spot-list-sm">
			
			<el-card class="box-card hidden-xs-only" style="height:100%" shadow="always">
				<div slot="header" class="clearfix">
					<el-autocomplete
					  :placeholder="$t('search')"
					  v-model="searchContent"
					  :id="searchBoxName"
					  :fetch-suggestions="searchQuery"
					  @select="selectInput"
					  clearable>
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-autocomplete>
					<LanguageSelect :initialLanguage="initialLanguage" :onChanged="onLanguageChanged"/>
				</div>
				<div style="overflow-y:auto">
					<div :style="`overflow-y:auto;height:${contentHeight}`" v-loading="loading">
						<div id="spot-list-sm-content">
							<SpotListItem v-for="item in splicedSpots" :isSelected="selectedOuid === item.ouid"  :spot="item" v-bind:key="item.ouid" :spotSelectedHandler="localSpotSelectedHandler"/>
						</div>
						<el-pagination
						:current-page="page"
						small
						background
						:hide-on-single-page="true"
						@next-click="onNextClick"
						@prev-click="onPrevClick"
						@current-change="onPageChanged"
						layout="prev, pager, next"
						:pager-size="spotsPerPage"
						:total="spots.length">
						</el-pagination>
					</div>
				</div>
			</el-card>
			
		</div>
		
		<el-card class="box-card hidden-sm-and-up xs-search" shadow="always">
			<div style="flex-grow:1">
				<el-autocomplete
				  :placeholder="$t('search')"
				  v-model="searchContent"
				  :id="searchBoxName"
				  :fetch-suggestions="searchQuery"
				  @select="selectInput"
				  
				  clearable>
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-autocomplete>
			</div>
			<div style="width:60px;margin-top:11px;padding-left:9px;box-sizing:border-box;">
				<LanguageSelect :initialLanguage="initialLanguage" :onChanged="onLanguageChanged"/>
			</div>
		</el-card>
		<InstallAppDialog :locale="locale"/>
		<div style="position:absolute;left:0;height:100vh;width:100%;" class="hidden-sm-and-up">
			<div style="position:absolute;width:100vw;height:100vh;bottom:0;box-sizing:border-box;" :class="'xs-card ' + extraClass">
				
				<el-card class="box-card hidden-sm-and-up" style="height:100%;" shadow="always" id="spot-list-xs">
					<div slot="header" class="clearfix" @click="swipeClickHandler">
						<div style="width:100%;text-align:center;margin:0 auto">
							<div :class="`swipe-touch${xsOpened ? ' opened': ''}`"></div>
						</div>
					</div>
					<div class="overflow-y:auto">
						<div :style="`overflow-y:auto;height:${contentHeight}`" v-loading="loading">
							<SpotListItem v-for="item in spots" :spot="item" v-bind:key="item.ouid" :spotSelectedHandler="localSpotSelectedHandler"/>
							<el-pagination
							:current-page="page"
							small
							background
							:hide-on-single-page="true"
							@next-click="onNextClick"
							@prev-click="onPrevClick"
							@current-change="onPageChanged"
							layout="prev, pager, next"
							:pager-size="spotsPerPage"
							:total="spots.length">
							</el-pagination>
						</div>
					</div>
				</el-card>
				
			</div>
		</div>
	
	</div>
</template>
<script>
import SpotListItem   from '@/components/SpotListItem.vue';
import LanguageSelect from '@/components/LanguageSelect.vue';
import SizeListener from '@/utils/SizeListener.js';
import InstallAppDialog from "@/components/InstallAppDialog.vue";

export default {
	name: 'SpotList',
	data: () => ({
		height: 0,
		cardHeight: 0,
		topMargin: 0,
		extraClass: 'hidden',
		searchContent: "",
		selectedOuid: null,
		counter: 0,
		page: 1,
		total: 0,
		spotsPerPage: 10,
		pagerCount: 5,
		contentHeight: 'auto',
		loading: true,
		xsOpened: false,
	}),
	props: {
		spots: Array,
		spotSelectedHandler: Function,
		searchBoxName: String,
		searchQuery: Function,
		selectInput: Function,
		onLanguageChanged: Function,
		initialLanguage: String,
		locale: {
			type: String,
			default: 'en'
		},
		isLoading: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		splicedSpots: function () {
			return this.spots.slice((this.page - 1) * this.spotsPerPage, (this.page) * this.spotsPerPage);
		}
	},
	components: {
		SpotListItem,
		LanguageSelect,
		InstallAppDialog
	},
	updated: function () {
		this.recountContentHeight();
	},
	created: function () {
		this.loading = this.isLoading;
		this.height    = window.screen.height;
		this.topMargin = this.height - 15;
		this.counter = this.spots.length;
	},
	mounted: function () {
		let self = this;
		this.cardHeight = document.getElementById('spot-list-xs').offsetHeight;
		this.$nextTick(self.recountContentHeight);
		SizeListener.set('SpotList.recountContentHeight', this.recountContentHeight);
	},
	methods: {
		setLoading: function (isLoading) {
			this.loading = isLoading;
		},
		recountContentHeight: function () {
			let ch = window.document.getElementById('spot-list-sm-content').offsetHeight,
				wh = window.innerHeight - 200;
			if (wh > ch) {
				this.contentHeight = 'auto';
				return;
			}
			if (ch === 0) {
				this.contentHeight = 'auto';
				return;
			}
			this.contentHeight = (wh) + 'px';
		},
		findPageOfSelected: function (ouid) {
			for (let i = 0; i < this.spots.length; i += 1) {
				if (this.spots[i].ouid === ouid) {
					let p = Math.ceil(i / this.spotsPerPage);
					if (p === 0) {
						return 1;
					}
					return Math.ceil(p);
				}
			}
			return 1;
		},
		onPageChanged: function (a) {
			this.page = a;
			this.recountContentHeight();
		},
		onPrevClick: function () {
			this.page -= 1;
			this.recountContentHeight();
		},
		onNextClick: function () {
			this.page += 1;
			this.recountContentHeight();
		},
		setSelectedSpot: function (ouid) {			
			this.selectedOuid = ouid;
			this.page = this.findPageOfSelected(ouid);
		},
		localSpotSelectedHandler: function (spot) {
			this.selectedOuid = spot.ouid;
			this.spotSelectedHandler(spot);
		},
		handleTop: function (touch) {
			this.extraClass = 'visible';
			window.scrollTo(0, 0);
		},
		handleBottom: function (touch) {
			this.extraClass = 'hidden';
			window.scrollTo(0, 0);
		},
		swipeHandler: function (direction, touch) {
			if (touch.isTrusted === true) {
				switch (direction) {
				case "top":    return this.handleTop(touch);
				case "bottom": return this.handleBottom(touch);
				}
			}
		},
		swipeClickHandler: function (direction, touch) {
			this.xsOpened = !this.xsOpened;
			if (this.xsOpened) {
				return this.handleTop();
			} else {
				return this.handleBottom();
			}
		}
	}
}
</script>
<style lang="scss">
$xs-search-height: 60px;
.spot-list-sm {	
	position:absolute;
	top:0;
	left:0;
	height:100vh;
	width:$spots-width;
	padding:1.5em;
	box-sizing:border-box;
	z-index:$z-index-high;
}
.swipe-touch {
	width:50px;
	border:1px solid #ddd;
	background:#eee;
	height:2px;
	border-radius:2px;
	margin:0 auto;
	transition: all .5s linear;
	&.opened {
		width:150px;
		transition: all .5s linear;
	}
}
.xs-search {
	position: fixed;
	top: 0;
	height: $xs-search-height;
	width:100vw;
	display: flex;
	.el-autocomplete {
		width:100%;
	}
	.el-card__body {
		padding: 10px 10px 5px 10px !important;
		box-sizing:border-box;
		width:100vw;
		display:flex;
		flex-direction:row;
	}
}
.xs-card {
	&.hidden {
		top:80vh;
		transition: all 0.5s linear;
	}
	&.visible {
		top: $xs-search-height;
		transition: all 0.3s linear;
	}
}
</style>

















